import {
    Object3D,SubtractiveBlending,
     Box3, Vector3,Color
} from 'three';

import bidello,{ component } from 'bidello';
import * as THREE from 'three';
import TWEEN from 'three/examples/jsm/libs/tween.module.min';

export class Dome extends component(Object3D) {

    init(){


        this.frontMesh = null;
        this.backMesh = null;

        this.domeFrontWall = null;
        this.domeFrontTop = null;
        this.domeFrontFadeTween = null;


        this.domeBackWall = null;
        this.domeBackTop = null;
        this.domeBackFadeTween = null;

        this.renderOrder = 1;
        this.fadeInTween = null;
        this.fadeOutTween = null;
        this.openDomeTween = null;
        this.cloneDomeTween = null;
        this.originalPosition = new Vector3();
        this.originalPosition.copy(this.position);

    }

    attachMesh(mesh){

        mesh.children.map((meshChild)=>{

            if (meshChild.name == "dome_front")this.attachFrontMesh(mesh);
            if (meshChild.name == "dome_back")this.attachBackMesh(mesh)

        });

    }

    attachFrontMesh(mesh){
        mesh.parent = this;
        this.frontMesh = mesh;
        mesh.children.map((meshChild)=>{

            if (meshChild.name == "dome_front_0"){

                this.domeFrontTop = meshChild;
                this.domeFrontTop.material.transparent = true;
                //this.domeFrontTop.material.blendingMode = SubtractiveBlending
                this.domeFrontTop.material.alphaTest = 0;
                this.domeFrontTop.material.opacity = 1;


            }
            if (meshChild.name == "dome_front_1"){

                this.domeFrontWall = meshChild;
                this.domeFrontWall.material.transparent = true;
                //this.domeFrontWall.material.blendingMode = SubtractiveBlending
                this.domeFrontWall.material.alphaTest = 0;
                this.domeFrontWall.material.opacity = 1;

            }

        });

        this.domeFrontPositionTween = new TWEEN.Tween(this.frontMesh.position).easing(TWEEN.Easing.Exponential.InOut);
        this.add(this.frontMesh);
    }

    attachBackMesh(mesh){

        mesh.parent = this;
        this.backMesh = mesh;
        mesh.children.map((meshChild)=>{


            if (meshChild.name == "dome_back_0"){

                this.domeBackTop = meshChild;
                this.domeBackTop.material.transparent = true;
                this.domeBackTop.material.blendingMode = SubtractiveBlending
                this.domeBackTop.material.alphaTest = 0;
                this.domeBackTop.material.opacity = 1;
                this.domeBackFadeTween = new TWEEN.Tween(this.domeBackTop.material).easing(TWEEN.Easing.Exponential.InOut);


            }
            if (meshChild.name == "dome_back_1"){

                this.domeBackWall = meshChild;
                this.domeBackWall.material.transparent = true;
                this.domeBackWall.material.blendingMode = SubtractiveBlending
                this.domeBackWall.material.alphaTest = 0;
                this.domeBackWall.material.opacity = 1;

            }

        });

        this.add(this.backMesh);

    }

    getCenter(){

        const box = new Box3().setFromObject(this);
        return box.getCenter(new Vector3());

    }

    getSizeBox (){

        const box = new Box3().setFromObject(this.frontMesh);
        box.expandByObject(this.backMesh)
        return  box.getSize(new Vector3())

    }

    setInvisible (){

        //this.meshModel.material.opacity = 0;

    }

    setVisible (){

        //this.meshModel.material.opacity = 1;

    }


    fadeOut (time = 3000){

        this.domeBackFadeTween.to({opacity:0},time).start().onUpdate(()=>{

            this.domeBackWall.material.opacity = this.domeBackTop.material.opacity;

        })
    }

    fadeIn(time = 3000){

        this.domeBackFadeTween.to({opacity:1},time).start().onUpdate(()=>{

            this.domeBackWall.material.opacity = this.domeBackTop.material.opacity;

        })

    }

    openDome (){

        this.domeFrontPositionTween.to({y:30},500).start();

    }

    closeDome (){

        this.domeFrontPositionTween.to({y:0},500).start();

    }

}



